import React from 'react';
import PropTypes from 'prop-types';
import TableCard from '../../ui/TableCard';
import { Avatar, Typography, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function currencyFormatter(value) {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(value);
}

const TopProductsTableCard = ({ rows = [], title = 'Productos más vendidos' }) => {
  // Detectar si alguna fila posee variante
  const hasVariant = rows.some((p) => p.variantTitle || p.variant);

  const columns = [
    {
      id: 'image',
      label: '',
      width: 60,
      render: (value) => (
        <Avatar
          variant="rounded"
          src={value || undefined}
          sx={{ 
            width: 48, 
            height: 48, 
            bgcolor: 'grey.100',
            border: '1px solid',
            borderColor: 'grey.300'
          }}
        >
          {!value && <i className="bi bi-image" style={{ color: '#666' }} />}
        </Avatar>
      ),
    },
    {
      id: 'product',
      label: 'Producto',
      minWidth: 200,
      render: (value) => (
        <Typography 
          variant="body2" 
          sx={{ 
            maxWidth: 200,
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={value} // Tooltip con nombre completo
        >
          {value}
        </Typography>
      ),
    },
    ...(hasVariant
      ? [{
          id: 'variant',
          label: 'Variante',
          render: (value) => (
            <Typography variant="body2" noWrap sx={{ maxWidth: 160 }}>
              {value || '-'}
            </Typography>
          ),
        }]
      : []),
    { id: 'sales', label: 'Ventas', align: 'right', render: (val) => (val > 0 ? val : '-') },
    {
      id: 'revenue',
      label: 'Ingresos',
      align: 'right',
      render: (value) => currencyFormatter(value),
    },
  ];

  const tableRows = Array.isArray(rows)
    ? rows.map((p) => ({
        image: p.imageUrl?.src || p.image || '',
        product: p.name || p.productTitle || 'Producto',
        variant: p.variantTitle || p.variant || '—',
        sales: Number(p.unitsSoldPaid || p.totalSold || p.totalSales || p.sales || 0),
        revenue: Number(p.revenuePaid || p.totalRevenue || p.revenue || 0),
      }))
    : [];

  const actionNode = (
    <MuiLink
      component={RouterLink}
      to="/products"
      underline="none"
      variant="body2"
      sx={{ fontWeight: 500 }}
    >
      Ver todos
    </MuiLink>
  );

  return <TableCard title={title} columns={columns} rows={tableRows} action={actionNode} />;
};

TopProductsTableCard.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default TopProductsTableCard;
